<!--
 @description 灰度配置-首页
 @author xiehan
 @date 2019/08/21
-->
<template>
  <div class="grayConfig__content">
    <div class="grayConfig__form">
      <el-form ref="searchForm"
        :model="searchForm"
        :inline="true">
        <el-form-item :label="$t('grayConfig.routeVersionName')">
          <el-input v-model="searchForm.routeVersionName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.tagName')">
          <el-input v-model="searchForm.tagName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeVersionGroup')">
          <g-select v-model="searchForm.routeVersionGroup"
            :list="select_group"
            :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.tagStatus')">
          <g-select v-model="searchForm.tagStatus"
            :list="select_status"
            :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.createTime')"
          input-width="auto">
          <el-form-item prop="createTimeStart">
            <el-date-picker value-format="timestamp"
              style="width: 180px;"
              v-model="searchForm.createTimeStart"
              type="datetime">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item prop="createTimeEnd"
            style="margin-left: 10px">
            <el-date-picker value-format="timestamp"
              style="width: 180px;"
              v-model="searchForm.createTimeEnd"
              type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.releaseTime')"
          input-width="auto">
          <el-form-item prop="releaseTimeStart">
            <el-date-picker value-format="timestamp"
              style="width: 180px;"
              v-model="searchForm.releaseTimeStart"
              type="datetime">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item prop="releaseTimeEnd"
            style="margin-left: 10px">
            <el-date-picker value-format="timestamp"
              style="width: 180px;"
              v-model="searchForm.releaseTimeEnd"
              type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="search"
            v-g-rac="gRac('grayConfig@search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary"
            @click="add"
            v-g-rac="gRac('grayConfig@add')">{{ $t('common.add') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div style="overflow: hidden;">
      <el-table :data="tableData"
        border>
        <el-table-column v-for="item in tableHead"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column :label="$t('common.handle')">
          <template slot-scope="scope">
            <el-dropdown @command="handleCommand">
              <el-button type="text">
                {{ $t('common.more') }}
                <i class="uk-icon-arrow-down uk-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- 判断不同状态禁用 -->
                <el-dropdown-item v-text="$t('common.edit')"
                  :command="handleCommandItem('edit',scope.row)"
                  v-g-rac="gRac('grayConfig@edit')"
                  :disabled="scope.row.oriStatus === '3' || scope.row.oriStatus === '4'"></el-dropdown-item>
                <el-dropdown-item v-text="$t('common.check')"
                  :command="handleCommandItem('check',scope.row)"
                  v-g-rac="gRac('grayConfig@check')"></el-dropdown-item>
                <el-dropdown-item v-text="$t('grayConfig.publish')"
                  :command="handleCommandItem('publish',scope.row)"
                  v-g-rac="gRac('grayConfig@publish')"
                  :disabled="scope.row.oriStatus === '3' || scope.row.oriStatus === '4'"></el-dropdown-item>
                <el-dropdown-item v-text="$t('grayConfig.rollback')"
                  :command="handleCommandItem('rollback',scope.row)"
                  v-g-rac="gRac('grayConfig@rollback')"
                  :disabled="scope.row.oriStatus === '0' || scope.row.oriStatus === '4'"></el-dropdown-item>
                <el-dropdown-item v-text="$t('grayConfig.cut')"
                  :command="handleCommandItem('cut',scope.row)"
                  v-g-rac="gRac('grayConfig@cutover')"
                  :disabled="scope.row.oriStatus !== '1' && scope.row.oriStatus !== '3'"></el-dropdown-item>
                <el-dropdown-item v-text="$t('grayConfig.end')"
                  :command="handleCommandItem('end',scope.row)"
                  v-g-rac="gRac('grayConfig@toend')"
                  :disabled="scope.row.oriStatus === '1'"></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="el-table-extend__pager">
        <el-pagination background
          @size-change="e_handleSizeChange"
          @current-change="e_handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="tablePageInfo.currentPage"
          :page-size="tablePageInfo.pageSize"
          :page-count="tablePageInfo.pageCount"
          :total="tablePageInfo.total">
        </el-pagination>
      </div>
    </div>
    <!-- 配置弹窗 -->
    <el-dialog :closeOnClickModal="false"
      :title="grayDiaTitle"
      :visible.sync="grayDiaVis"
      width="800px">
      <!-- 第一步 -->
      <el-form ref="handleForm"
        :model="handleForm"
        input-width="180px"
        label-width="80px"
        :rules="rules"
        :inline="true"
        v-show="step == 1">
        <el-form-item :label="$t('grayConfig.routeVersionName')"
          prop="routeVersionName">
          <el-input v-model="handleForm.routeVersionName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeRuleName')"
          prop="routeRuleName">
          <el-input v-model="handleForm.routeRuleName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeVersionGroup')"
          prop="routeVersionGroup">
          <g-select v-model="handleForm.routeVersionGroup"
            :list="select_group"></g-select>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeStrategyName')"
          prop="routeStrategyType">
          <g-select v-model="handleForm.routeStrategyType"
            :list="select_strategy"></g-select>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.tagName')"
          prop="tagName">
          <el-input v-model="handleForm.tagName"
            @change="onTagNameChange"></el-input>
        </el-form-item>
      </el-form>
      <!-- 第二步 && 按Key -->
      <div v-show="step == 2 && handleForm.routeStrategyType == 'key_router'">
        <el-form ref="keySearchForm"
          :model="keySearchForm"
          :inline="true">
          <el-form-item :label="$t('grayConfig.routeKey')">
            <el-input v-model="keySearchForm.routeKey"></el-input>
          </el-form-item>
          <el-form-item :label="$t('grayConfig.userName')">
            <el-input v-model="keySearchForm.userName"></el-input>
          </el-form-item>
          <el-form-item input-width="70px">
            <el-button type="primary"
              @click="searchKeyTable(true)">{{ $t('common.search') }}</el-button>
          </el-form-item>
        </el-form>
        <el-upload class="grayConfig_upload ilb"
          ref="upload"
          :data="routeInfo"
          :action="uploadUrl"
          :before-upload="checkUpload"
          :on-success="uploadSuccess"
          :show-file-list="showFileList"
          name="routeKeyFile">
          <el-button type="primary"
            slot="trigger"
            :disabled="!canConfirm">{{$t('grayConfig.upload')}}</el-button>
        </el-upload>
        <el-button type="primary"
          style="margin-left: 8px;"
          @click="exportKey">{{ $t('grayConfig.export') }}</el-button>
        <el-button type="primary"
          @click="downloadTemp">{{ $t('grayConfig.download') }}</el-button>
        <el-button type="primary"
          @click="cleanKey">{{ $t('grayConfig.clearData') }}</el-button>
        <div style="margin-top: 10px;">
          <el-table-extend :data="keyTableData"
            :head="keyTableHead"
            :currentChange="keyCurrentChange"
            :sizeChange="keySizeChange"
            border>
          </el-table-extend>
        </div>
      </div>
      <!-- 第二步 && 百分比 -->
      <div v-show="step == 2 && handleForm.routeStrategyType == 'percent_router'">
        <el-form ref="stepForm"
          :model="stepForm"
          input-width="180px"
          label-width="80px"
          :rules="stepRules"
          :inline="true">
          <el-form-item :label="$t('grayConfig.percent')"
            prop="percent">
            <el-input-number v-model="stepForm.percent"
              :min="0"
              :max="100">
            </el-input-number>
          </el-form-item>
          <el-form-item label-width="10px"
            label="%">
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="grayDiaVis = false"
          v-text="$t('common.cancel')"></el-button>
        <el-button type="primary"
          v-text="$t('common.confirm')"
          @click="confirm"
          v-show="step == 2"
          :disabled="!canConfirm"></el-button>
        <el-button type="primary"
          v-text="$t('dataDictionary.back')"
          @click="step--"
          v-show="step == 2"></el-button>
        <el-button type="primary"
          v-text="$t('dataDictionary.next')"
          @click="nextStep()"
          v-show="step == 1"></el-button>
      </span>
    </el-dialog>
    <!-- 查看弹窗 -->
    <el-dialog :closeOnClickModal="false"
      :title="$t('common.check')"
      :visible.sync="grayDetailDiaVis"
      width="600px">
      <!-- 第一步 -->
      <el-form ref="detailForm"
        :model="detailForm"
        input-width="180px"
        label-width="80px"
        :inline="true"
        v-show="step == 1">
        <el-form-item :label="$t('grayConfig.routeVersionName')">
          <span class="check-detail-fix"
            v-text="detailForm.routeVersionName"
            :title="detailForm.routeVersionName"></span>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeRuleName')">
          <span class="check-detail-fix"
            v-text="detailForm.routeRuleName"
            :title="detailForm.routeRuleName"></span>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeVersionGroup')">
          <span class="check-detail-fix"
            v-text="detailForm.routeVersionGroup"
            :title="detailForm.routeVersionGroup"></span>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.routeStrategyName')">
          <span class="check-detail-fix"
            v-text="detailForm.routeStrategyName"
            :title="detailForm.routeStrategyName"></span>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.tagName')">
          <span class="check-detail-fix"
            v-text="detailForm.tagName"
            :title="detailForm.tagName"></span>
        </el-form-item>
        <el-form-item :label="$t('grayConfig.percent')"
          v-show="detailForm.routeStrategyType === 'percent_router'">
          <span class="check-detail-fix"
            v-text="detailForm.percent"
            :title="detailForm.percent"></span>
        </el-form-item>
      </el-form>
      <!-- 第二步 && 按Key -->
      <div v-show="step == 2 && detailForm.routeStrategyType == 'key_router'">
        <el-form ref="keySearchForm"
          :model="keySearchForm"
          :inline="true">
          <el-form-item :label="$t('grayConfig.routeKey')">
            <el-input v-model="keySearchForm.routeKey"></el-input>
          </el-form-item>
          <el-form-item :label="$t('grayConfig.userName')">
            <el-input v-model="keySearchForm.userName"></el-input>
          </el-form-item>
          <el-form-item input-width="70px">
            <el-button type="primary"
              @click="searchKeyTable(true)">{{ $t('common.search') }}</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary"
          @click="exportKey">{{ $t('grayConfig.export') }}</el-button>
        <div style="margin-top: 10px;">
          <el-table-extend :data="keyTableData"
            :head="keyTableHead"
            :currentChange="keyCurrentChange"
            :sizeChange="keySizeChange"
            border>
          </el-table-extend>
        </div>
      </div>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="grayDetailDiaVis = false"
          v-text="$t('common.close')"></el-button>
        <el-button type="primary"
          v-text="$t('dataDictionary.back')"
          @click="step--"
          v-show="step == 2 && detailForm.routeStrategyType === 'key_router'"></el-button>
        <el-button type="primary"
          @click="nextStep('detail')"
          v-text="$t('dataDictionary.next')"
          v-show="step == 1 && detailForm.routeStrategyType === 'key_router'"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table from "@/components/mixins/table";
import dic from "@/components/mixins/dic";
import grayConfigBiz from "@/logic/continuousDelivery/grayConfigBiz";
import exportTips from "@/components/mixins/exportTips";
import { extend } from "@/utils/tool";
import TimeFormat from "@/utils/timeFormat";
import validateConfig from "@/utils/validate";
import GlobalConfig from "@/utils/global-config";
import rac from "@/plugins/rac-mixin.js";
export default {
  mixins: [rac, dic, table, exportTips],
  data() {
    const that = this;
    return {
      tableData: [],
      tableHead: [],
      tablePageInfo: {
        currentPage: 1,
        pageSize: 10,
        pageCount: 0,
        total: 0
      },
      searchForm: {
        routeVersionName: "",
        tagName: "",
        routeVersionGroup: "",
        tagStatus: "",
        createTimeStart: new Date().getTime() - 86400000,
        createTimeEnd: "",
        releaseTimeStart: "",
        releaseTimeEnd: ""
      },
      routeInfo: {
        routeInfo: {}
      },
      uploadUrl: "/ops/grayreleased/tag/import",
      showFileList: false,
      grayDiaTitle: "",
      grayDiaVis: false,
      handleForm: {
        routeVersionName: "",
        routeRuleName: "",
        routeVersionGroup: "",
        routeStrategyType: "",
        tagName: ""
      },
      select_group: {},
      select_status: {},
      select_strategy: {},
      editInfo: {},
      rules: {
        routeVersionName: [
          {
            required: true,
            message: `${that.$t("common.entryTips")}${that.$t(
              "grayConfig.routeVersionName"
            )}`,
            trigger: "blur"
          }
        ],
        routeRuleName: [
          {
            required: true,
            message: `${that.$t("common.entryTips")}${that.$t(
              "grayConfig.routeRuleName"
            )}`,
            trigger: "blur"
          }
        ],
        tagName: [
          {
            required: true,
            message: `${that.$t("common.entryTips")}${that.$t(
              "grayConfig.tagName"
            )}`,
            trigger: "blur"
          }
        ]
      },
      stepRules: {
        percent: [{ ...validateConfig.common.isAmount }]
      },
      stepForm: {
        percent: ""
      },
      step: 1,
      keySearchForm: {
        routeKey: "",
        userName: ""
      },
      keyTableData: {},
      keyTableHead: [],
      keyCurrentPage: 1,
      keyPerPageCount: 10,
      grayDetailDiaVis: false,
      detailForm: {
        routeVersionName: "",
        routeRuleName: "",
        routeVersionGroup: "",
        routeStrategyName: "",
        tagName: "",
        percent: "",
        routeStrategyType: ""
      },
      doExport: null,
      canPublish: true,
      canConfirm: true
    };
  },
  methods: {
    async preInitTable() {
      await Promise.all([
        this.dGetDictionaryByCode("groupType"),
        this.dGetDictionaryByCode("tag_status"),
        this.dGetDictionaryByCode("route_strategy_type")
      ]);
      this.select_group = { ...this.dDictionary.groupType };
      this.select_status = { ...this.dDictionary.tag_status };
      delete this.select_status[5];
      this.select_strategy = { ...this.dDictionary.route_strategy_type };
      this.handleForm.routeVersionGroup = Object.keys(this.select_group)[0];
      this.handleForm.routeStrategyType = Object.keys(this.select_strategy)[0];
      this.initTable();
    },
    // 表格下拉菜单
    handleCommand(command) {
      switch (command.key) {
        case "edit":
          this.editInfo = { ...command.row };
          this.editInfo["routeVersionGroup"] = Object.keys(
            this.select_group
          ).find(
            item => this.select_group[item] === this.editInfo.routeVersionGroup
          );
          this.step = 1;
          this.grayDiaVis = true;
          this.grayDiaTitle = this.$t("common.edit");
          for (let i in this.handleForm) {
            this.handleForm[i] = this.editInfo[i];
          }
          this.clearValidate();
          break;
        case "check":
          this.editInfo = { ...command.row };
          this.step = 1;
          if (command.row.routeStrategyType === "percent_router") {
            grayConfigBiz
              .queryRuleDetail({
                routeRuleId: command.row.routeRuleId,
                routeStrategyType: command.row.routeStrategyType
              })
              .then(data => {
                for (let i in this.detailForm) {
                  this.detailForm[i] = command.row[i];
                }
                this.detailForm["percent"] = `${data.dataList[0].percent}%`;
                this.grayDetailDiaVis = true;
              });
          } else {
            for (let i in this.detailForm) {
              this.detailForm[i] = command.row[i];
            }
            this.grayDetailDiaVis = true;
          }
          break;
        case "publish":
          if (this.canPublish) {
            this.canPublish = false;
            grayConfigBiz
              .publish({ tagId: command.row.tagId })
              .then(() => {
                this.canPublish = true;
                this.successMessage();
                this.searchTable();
              })
              .catch(() => {
                this.canPublish = true;
              });
          }
          break;
        case "rollback":
          this.confirmMsgBox(this.$t("grayConfig.rollbackTip")).then(() => {
            grayConfigBiz.rollback({ tagId: command.row.tagId }).then(() => {
              this.successMessage();
              this.searchTable();
            });
          });
          break;
        case "cut":
          grayConfigBiz.cutover({ tagId: command.row.tagId }).then(() => {
            this.successMessage();
            this.searchTable();
          });
          break;
        case "end":
          {
            let tip = "";
            if (command.row.oriStatus == 3) tip = this.$t("grayConfig.cutTip");
            if (command.row.oriStatus == 0 || command.row.oriStatus == 2)
              tip = this.$t("grayConfig.confirmEndTip");
            let requery = () => {
              grayConfigBiz.toend({ tagId: command.row.tagId }).then(() => {
                this.successMessage();
                this.searchTable();
              });
            };
            tip ? this.confirmMsgBox(tip).then(requery) : requery();
          }
          break;
        default:
          break;
      }
    },
    handleCommandItem(item, row) {
      return { key: item, row: row };
    },
    e_handleSizeChange(val) {
      this.tablePageInfo.pageSize = val;
      this.tablePageInfo.currentPage = 1;
      this.searchTable();
    },
    e_handleCurrentChange(val) {
      this.tablePageInfo.currentPage = val;
      this.searchTable();
    },
    initTable() {
      this.keyTableHead = [
        { key: "routeKey", label: this.$t("grayConfig.routeKey") },
        { key: "userName", label: this.$t("grayConfig.userName") },
        { key: "infoDesc", label: this.$t("grayConfig.infoDesc") }
      ];
      let key = [
        "tagId",
        "routeVersionName",
        "routeVersionGroup",
        "tagName",
        "routeRuleName",
        "routeStrategyName",
        "tagStatus",
        "tagCreateTime",
        "releaseTime"
      ];
      key.map(item => {
        this.tableHead.push({
          key: item,
          label: this.$t("grayConfig.table." + item)
        });
      });
      this.searchTable();
    },
    search() {
      this.tablePageInfo.currentPage = 1;
      this.tablePageInfo.pageSize = 10;
      this.searchTable();
    },
    searchTable() {
      const reqData = extend(
        true,
        {
          currentPage: this.tablePageInfo.currentPage,
          perPageCount: this.tablePageInfo.pageSize
        },
        this.searchForm
      );
      for (let i in reqData) {
        if (reqData[i] === "" || reqData[i] === null) {
          delete reqData[i];
        }
      }
      if (!reqData.createTimeEnd) reqData.createTimeEnd = new Date().getTime();
      grayConfigBiz.queryAllInfo(reqData).then(data => {
        if (data && data.dataList) {
          data.dataList.map(item => {
            item.tagCreateTime = TimeFormat.getFormatTime(item.tagCreateTime);
            item.releaseTime = TimeFormat.getFormatTime(item.releaseTime);
            item.oriStatus = item.tagStatus;
            item.routeVersionGroup = this.select_group[item.routeVersionGroup];
            item.tagStatus = this.select_status[item.tagStatus];
          });
        }
        this.tablePageInfo = {
          currentPage: data.currentPage,
          pageSize: data.perPageCount,
          pageCount: data.totalPageCount,
          total: data.totalCount
        };
        this.tableData = data.dataList;
      });
    },
    add() {
      this.step = 1;
      this.grayDiaVis = true;
      this.grayDiaTitle = this.$t("common.add");
      this.editInfo = {};
      this.resetHandleForm();
      this.keySearchForm = {
        routeKey: "",
        userName: ""
      };
      this.keyTableData = {};
      this.clearValidate();
    },
    resetHandleForm() {
      this.handleForm = {
        routeVersionName: "",
        routeRuleName: "",
        routeVersionGroup: Object.keys(this.select_group)[0],
        routeStrategyType: Object.keys(this.select_strategy)[0],
        tagName: ""
      };
      this.stepForm = {
        percent: ""
      };
    },
    nextToSearch() {
      this.keySearchForm = {
        routeKey: "",
        userName: ""
      };
      const reqData = extend(
        true,
        {
          perPageCount: 10,
          currentPage: 1,
          routeStrategyType: "key_router",
          routeRuleId: this.editInfo.routeRuleId
        },
        this.keySearchForm
      );
      grayConfigBiz.queryRuleDetail(reqData).then(data => {
        this.setKeyTableData(data);
        this.step = 2;
      });
    },
    nextStep(isDetail) {
      if (isDetail) {
        this.nextToSearch();
      } else {
        this.$refs["handleForm"].validate(valid => {
          if (valid) {
            // 如果是编辑 否则 新增
            if (this.grayDiaTitle === this.$t("common.edit")) {
              // 如果是KEY 否则 百分比
              if (this.handleForm.routeStrategyType === "key_router") {
                this.nextToSearch();
              } else {
                let checkObj = {
                  routeRuleId: this.editInfo.routeRuleId,
                  routeStrategyType: this.editInfo.routeStrategyType
                };
                grayConfigBiz.queryRuleDetail(checkObj).then(data => {
                  if (data.dataList && data.dataList.length > 0) {
                    this.stepForm = {
                      percent: data.dataList[0].percent
                    };
                  }
                  this.step = 2;
                });
              }
            } else {
              this.step = 2;
            }
          } else {
            return false;
          }
        });
      }
    },
    confirm() {
      this.$refs["stepForm"].validate(valid => {
        if (valid) {
          this.canConfirm = false;
          let saveObj =
            this.handleForm.routeStrategyType === "percent_router"
              ? { ...this.handleForm, ...this.stepForm }
              : { ...this.handleForm, finishSign: true };
          saveObj.routeStrategyName = this.select_strategy[
            saveObj["routeStrategyType"]
          ];
          // 如果是编辑状态或者新增状态时重复导入的情况
          if (
            this.grayDiaTitle === this.$t("common.edit") ||
            Object.keys(this.editInfo).length > 0
          ) {
            saveObj.tagId = this.editInfo.tagId;
            saveObj.routeRuleId = this.editInfo.routeRuleId;
            saveObj.routeVersionId = this.editInfo.routeVersionId;
          }
          grayConfigBiz
            .upsertAllInfo(saveObj)
            .then(data => {
              this.canConfirm = true;
              this.grayDiaVis = false;
              this.searchTable();
              this.successMessage();
            })
            .catch(() => {
              this.canConfirm = true;
            });
        } else {
          return false;
        }
      });
    },
    clearValidate() {
      this.$nextTick(() => {
        this.$refs["handleForm"].clearValidate();
        this.$refs["stepForm"].clearValidate();
      });
    },
    successMessage() {
      this.$message({
        message: this.$t("common.success"),
        type: "success"
      });
    },
    confirmMsgBox(tip) {
      return this.$confirm(tip, this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      });
    },
    downloadTemp() {
      GlobalConfig.getConfig().then(data => {
        window.open(
          `${
            data.crmHost
          }/htemp/resources/import_gray_released_user_template.xls`
        );
      });
    },
    cleanKey() {
      if (
        Object.keys(this.editInfo).length <= 0 ||
        this.editInfo.keyList === null ||
        this.editInfo.keyList.length <= 0
      ) {
        this.$message({
          message: this.$t("grayConfig.importTips"),
          type: "warning"
        });
      } else {
        grayConfigBiz
          .clean({
            routeRuleId: this.editInfo.routeRuleId
          })
          .then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            this.searchKeyTable(true);
          });
      }
    },
    checkUpload(file, fileList) {
      const reg = /^.*\.(?:xls|xlsx|XLS|XLSX)$/i;
      if (!reg.test(file.name)) {
        this.$message({
          message: this.$t("grayConfig.uploadRule"),
          type: "warning"
        });
        return false;
      } else {
        let importData = {
          ...this.handleForm,
          routeStrategyName: this.select_strategy[
            this.handleForm.routeStrategyType
          ],
          finishSign: false
        };
        // 如果是编辑状态或者新增状态时重复导入的情况
        if (
          this.grayDiaTitle === this.$t("common.edit") ||
          Object.keys(this.editInfo).length > 0
        ) {
          importData.routeRuleId = this.editInfo.routeRuleId;
          importData.routeVersionId = this.editInfo.routeVersionId;
          importData.tagId = this.editInfo.tagId;
        }
        this.routeInfo.routeInfo = JSON.stringify(importData);
        this.canConfirm = false;
      }
    },
    uploadSuccess(response, file, fileList) {
      if (response.resultCode === "00000000") {
        this.canConfirm = true;
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        this.keySearchForm = {
          routeKey: "",
          userName: ""
        };
        // 如果是新增，防止重复导入的情况，填入editInfo
        if (this.grayDiaTitle === this.$t("common.add")) {
          this.editInfo = response.data;
        }
        this.searchTable();
        this.searchKeyTable(true);
      } else {
        this.canConfirm = true;
        this.$message({
          message: response.resultDesc,
          type: "warning"
        });
      }
    },
    setKeyTableData(data) {
      this.editInfo.keyList = data.dataList;
      this.keyTableData = data;
    },
    searchKeyTable(fromClick = false) {
      if (fromClick) {
        this.keyCurrentPage = 1;
        this.keyPerPageCount = 10;
      }
      const reqData = extend(
        true,
        {
          perPageCount: this.keyPerPageCount,
          currentPage: this.keyCurrentPage,
          routeStrategyType: "key_router",
          routeRuleId: this.editInfo.routeRuleId
        },
        this.keySearchForm
      );
      grayConfigBiz.queryRuleDetail(reqData).then(data => {
        this.setKeyTableData(data);
      });
    },
    keyCurrentChange(val) {
      this.keyCurrentPage = val;
      this.searchKeyTable();
    },
    keySizeChange(val) {
      this.keyCurrentPage = 1;
      this.keyPerPageCount = val;
      this.searchKeyTable();
    },
    exportKey() {
      if (this.editInfo.routeRuleId) {
        const search = extend(
          {
            routeRuleId: this.editInfo.routeRuleId,
            routeStrategyType: "key_router"
          },
          this.keySearchForm
        );
        if (!this.doExport) this.doExport = this.exportKeyTable();
        this.doExport(search);
      }
    },
    exportKeyTable() {
      const that = this;
      const list = {
        routeKey: this.$t("grayConfig.routeKey"),
        userName: this.$t("grayConfig.userName"),
        infoDesc: this.$t("grayConfig.infoDesc")
      };
      return function(search) {
        that.exRenderBefore();
        grayConfigBiz.exportKeyTable(
          list,
          search,
          that.exRenderTips,
          that.exRenderFail
        );
      };
    },
    onTagNameChange(tag) {
      this.handleForm.tagName = tag.replace(/[^\u0000-\u00FF]/g, "");
    }
  },
  mounted() {
    this.preInitTable();
  }
};
</script>

<style scoped>
.check-detail-fix {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
</style>